import axios from '../../api/axios';
import { showSuccess, showError } from '../../Components/reuse/Toast';
import { validateToken } from './validateAction';

// Action Types
export const CONNECT_KLAVIYO_REQUEST = 'CONNECT_KLAVIYO_REQUEST';
export const CONNECT_KLAVIYO_SUCCESS = 'CONNECT_KLAVIYO_SUCCESS';
export const CONNECT_KLAVIYO_FAILURE = 'CONNECT_KLAVIYO_FAILURE';
export const DISCONNECT_KLAVIYO_REQUEST = 'DISCONNECT_KLAVIYO_REQUEST';
export const DISCONNECT_KLAVIYO_SUCCESS = 'DISCONNECT_KLAVIYO_SUCCESS';
export const DISCONNECT_KLAVIYO_FAILURE = 'DISCONNECT_KLAVIYO_FAILURE';

// Action Creators
export const connectKlaviyoRequest = () => ({
  type: CONNECT_KLAVIYO_REQUEST
});

export const connectKlaviyoSuccess = (data) => ({
  type: CONNECT_KLAVIYO_SUCCESS,
  payload: data
});

export const connectKlaviyoFailure = (error) => ({
  type: CONNECT_KLAVIYO_FAILURE,
  payload: error
});

export const connectKlaviyo = (configData) => {
  return async (dispatch) => {
    dispatch(connectKlaviyoRequest());
    
    try {
      const response = await axios.post('klaviyo/connect', configData);
      
      // Show success message from API response
      showSuccess(response.data.message);
      
      // Update auth data to reflect the new configuration
      dispatch(validateToken());
      
      dispatch(connectKlaviyoSuccess(response.data));
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || 'Failed to connect Klaviyo';
      showError(errorMessage);
      dispatch(connectKlaviyoFailure(errorMessage));
    }
  };
};

// Disconnect Klaviyo Integration
export const disconnectKlaviyo = () => {
  return async (dispatch) => {
    dispatch({ type: DISCONNECT_KLAVIYO_REQUEST });
    try {
      const response = await axios.delete('klaviyo/disconnect');
      const data = response?.data || {};
      if (data?.success) {
        showSuccess(data?.message || 'Klaviyo disconnected successfully');
        dispatch(validateToken());
        dispatch({ type: DISCONNECT_KLAVIYO_SUCCESS, payload: data });
        return data;
      }
      const message = data?.message || 'Failed to disconnect Klaviyo';
      showError(message);
      dispatch({ type: DISCONNECT_KLAVIYO_FAILURE, error: message });
      return data;
    } catch (error) {
      const message = error?.response?.data?.message || error?.response?.data?.error || 'Failed to disconnect Klaviyo';
      showError(message);
      dispatch({ type: DISCONNECT_KLAVIYO_FAILURE, error: message });
      return { success: false, message };
    }
  };
};

